export class GoogleWorkspaceUserRestoreData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceRestoreWorkload>",
            "format": ""
        },
        {
            "name": "everyApp",
            "baseName": "everyApp",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
